import React from "react";
import { AppstoreAddOutlined } from "@ant-design/icons";
import Button from "../../../shared/globalStyling/Button";
import { PageHeaderLayout } from "../../../shared/layout";
import DownloadAdUnitButton from "../components/DownloadAdUnitButton";
import { useCreativeNavigation } from "../hooks/useCreativeNavigation";

const PageHeaderLayoutComponent = ({ adgroupinfo, mediaType = "DISPLAY" }) => {
  const { navigateBack } = useCreativeNavigation();
  const creativeKeys =
    adgroupinfo &&
    adgroupinfo.adGroupCreatives &&
    adgroupinfo.adGroupCreatives.medias
      ? adgroupinfo.adGroupCreatives.medias.map(media => media.key)
      : [];
  return (
    <PageHeaderLayout
      titleIcon={<AppstoreAddOutlined />}
      title={
        adgroupinfo && adgroupinfo.adGroupCreatives
          ? adgroupinfo.adGroupCreatives.name
          : ""
      }
      centerContent={
        <div>
          <DownloadAdUnitButton
            creativeKeys={creativeKeys}
            label="Download Ad Group"
          />
          <Button
            type="default"
            onClick={() => navigateBack({
              mediaType: mediaType,
              isAdGroup: true
            })}
          >
            Back
          </Button>
        </div>
      }
    />
  );
};

export default PageHeaderLayoutComponent;
